import { Container } from '@pwskills/rachnaui';
import React, { useContext } from 'react';
import ProfessionalThemeHeader from '@/components/common/Header/ProfessionalThemeHeader';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import SuccessStoryCards from '@/components/common/SuccessStoryCards';

const SuccessStories = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { successStories } = courseDetails?.courseMetaDetails || {};

  return (
    <section id="success" data-title="Placement" className=" bg-blue-50">
      <Container className=" py-8 medium:pt-14 medium:pb-[52px] medium:!px-8 large:!px-20 flex flex-col gap-6">
        <ProfessionalThemeHeader
          title="Real Impact: Celebrating 
          Success Stories"
          subtitle="Unleashing Expertise That Delivers : A Record of Excellence"
        />
        {successStories && <SuccessStoryCards successStories={successStories} />}
      </Container>
    </section>
  );
};

export default SuccessStories;
